/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_PriceInputs */

const en_fix_price = /** @type {(inputs: Fix_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const de_fix_price = /** @type {(inputs: Fix_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Fix_PriceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_price = /** @type {((inputs?: Fix_PriceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_PriceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_price(inputs)
	return en_fix_price(inputs)
});